// Known URL-shortener hosts. Kept in one place so the list is easy to extend.
// NoteRouter's own message link is injected server-side (via the `shorturl`
// placeholder) and never appears in user input, so it is never flagged here.
export const SHORTENER_DOMAINS = [
  'bit.ly',
  'tinyurl.com',
  't.co',
  'goo.gl',
  'ow.ly',
  'is.gd',
  'buff.ly',
  'rebrand.ly',
];

const SHORTENER_SET = new Set(SHORTENER_DOMAINS.map(d => d.toLowerCase()));

const isShortenerHost = host =>
  SHORTENER_SET.has(host) ||
  SHORTENER_DOMAINS.some(domain => host.endsWith(`.${domain}`));

// Matches URL-like tokens with or without a scheme (e.g. `bit.ly/x`,
// `https://tinyurl.com/y`, `www.t.co`) and captures the host.
const URL_LIKE =
  /(?:https?:\/\/)?(?:www\.)?([a-z0-9-]+(?:\.[a-z0-9-]+)+)(?:[/:?#]\S*)?/gi;

// Returns true when `text` contains a link on any known shortener host.
export const containsShortenedUrl = (text = '') => {
  if (!text) return false;
  URL_LIKE.lastIndex = 0;
  let match;
  while ((match = URL_LIKE.exec(text)) !== null) {
    const host = match[1].toLowerCase();
    if (isShortenerHost(host)) return true;
  }
  return false;
};
